import type React from "react";
import { SWReactCountryIcons } from "@similarweb/icons";
import { ChipItemTableCell } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import CountryService from "app/services/CountryService";
import { i18nFilter } from "app/filters/i18nFilter";
import { SegmentsTooltipContent } from "app/pages/digital-suite/home-page/components/CustomAssets/SegmentsTooltipContent/SegmentsTooltipContent";
import {
    ItemsList,
    ChipWrapper,
} from "app/pages/digital-suite/home-page/components/CustomAssets/KeywordListHoverFooter/styledComponents";
import { SharedTooltipContent } from "app/pages/digital-suite/home-page/components/CustomAssets/Assets/Asset/styledComponents";

interface IKeywordListHoverFooterProps {
    keywords: string[];
    countryCode: number;
}

const NUM_OF_KEYWORDS_TO_SHOW = 15;

export const KeywordListHoverFooter: React.FC<IKeywordListHoverFooterProps> = ({ keywords, countryCode }) => {
    const i18n = i18nFilter();

    const tooltipList = keywords.slice(0, NUM_OF_KEYWORDS_TO_SHOW);
    if (keywords.length > NUM_OF_KEYWORDS_TO_SHOW) {
        tooltipList.push(
            i18n("digitalmarketing.homepage.custom_assets.keywordLists.tooltip.more", {
                amount: keywords.length - NUM_OF_KEYWORDS_TO_SHOW,
            }),
        );
    }

    return (
        <ItemsList>
            <PlainTooltip
                tooltipContent={
                    <SegmentsTooltipContent
                        list={tooltipList}
                        title={`${keywords.length} ${i18n(
                            "digitalmarketing.homepage.custom_assets.keywordLists.tooltip.segments.keywords",
                        )}`}
                    />
                }
                placement={"right"}
                variation={"white"}
                debounce={200}
                allowHover
            >
                <ChipWrapper>
                    <ChipItemTableCell
                        text={i18n("digitalmarketing.homepage.custom_assets.keywordLists.chip", {
                            amount: keywords.length,
                        })}
                        hideActionButton={true}
                        maxAmountOfCharacters={15}
                    />
                </ChipWrapper>
            </PlainTooltip>
            <PlainTooltip
                tooltipContent={
                    <SharedTooltipContent>
                        <div>{`${i18n("digitalmarketing.homepage.custom_assets.showing")} ${
                            CountryService.getCountryById(countryCode).text
                        }`}</div>
                    </SharedTooltipContent>
                }
                placement={"bottom"}
                debounce={200}
            >
                <SWReactCountryIcons
                    countryCode={countryCode}
                    size={"xs"}
                />
            </PlainTooltip>
        </ItemsList>
    );
};
